/* PREST Cart  |  20.07.2026
 * SICHERHEIT: Der Checkout darf nie brechen.
 *  - Alles in try/catch, Event-Delegation auf document (ueberlebt Neu-Rendern).
 *  - Kein Eingriff in das Checkout-Formular, keine Submit-Handler.
 *
 * SPRACHEN: Die Buttontexte kommen aus window.prestT, das snippets/prest-cart-boost.liquid
 * je nach request.locale.iso_code setzt (de, en, fr, nl, pl). Faellt das aus, greifen die
 * deutschen Rueckfallwerte unten. Texte werden NICHT hier gepflegt, sondern in der Vorlage,
 * damit es genau eine Quelle gibt.
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var BUSY = false;

  /* Uebersetzung mit deutschem Rueckfall. Wird bei jedem Zugriff neu gelesen,
     weil window.prestT erst beim Rendern des Warenkorbs gesetzt wird. */
  function T(schluessel, rueckfall) {
    try {
      var t = window.prestT;
      if (t && typeof t[schluessel] === 'string' && t[schluessel].length) return t[schluessel];
    } catch (e) {}
    return rueckfall;
  }
  function tAdd() { return T('add', 'Hinzufügen'); }
  function tAdding() { return tAdd() + ' …'; }          /* Lade-Zustand, sprachneutral durch Auslassungspunkte */
  function tChoose() { return T('choose', 'Bitte Größe wählen'); }
  function tUnavailable() { return T('unavailable', 'Nicht verfügbar'); }

  function log(e) { if (window.console && console.warn) console.warn('[prest-cart]', e); }
  function on(sel, ev, fn) {
    document.addEventListener(ev, function (e) {
      try {
        var t = e.target && e.target.closest ? e.target.closest(sel) : null;
        if (t) fn(e, t);
      } catch (err) { log(err); }
    }, false);
  }

  function refreshDrawer() {
    return fetch(ROOT + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.drawer__inner');
        var live = document.querySelector('#CartDrawer .drawer__inner');
        if (!fresh || !live) throw new Error('drawer nicht gefunden');
        live.innerHTML = fresh.innerHTML;
        var d = document.querySelector('cart-drawer');
        if (d) d.classList.remove('is-empty');
        setTimeout(pfeileAktualisieren, 60);
      })
      .then(function () {
        return fetch(ROOT + '?section_id=cart-icon-bubble')
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
            var live = document.querySelector('#cart-icon-bubble');
            if (fresh && live && fresh.innerHTML) live.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      });
  }

  /* ---------- Empfehlungs-Slider: Pfeile ---------- */
  function pfeileAktualisieren() {
    try {
      var rail = document.querySelector('.prest-up__rail');
      var prev = document.querySelector('[data-prest-rail="prev"]');
      var next = document.querySelector('[data-prest-rail="next"]');
      if (!rail || !prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max;
    } catch (e) { log(e); }
  }

  on('[data-prest-rail]', 'click', function (ev, btn) {
    ev.preventDefault();
    var rail = document.querySelector('.prest-up__rail');
    if (!rail) return;
    var card = rail.querySelector('.prest-up__card');
    var step = card ? card.getBoundingClientRect().width + 10 : 140;
    var richtung = btn.getAttribute('data-prest-rail') === 'next' ? 1 : -1;
    rail.scrollBy({ left: step * richtung * 2, behavior: 'smooth' });
    setTimeout(pfeileAktualisieren, 420);
  });

  document.addEventListener('scroll', function (e) {
    try {
      if (e.target && e.target.classList && e.target.classList.contains('prest-up__rail')) pfeileAktualisieren();
    } catch (err) {}
  }, true);

  /* ---------- Groessenwahl ---------- */
  on('.prest-up__size', 'click', function (ev, btn) {
    if (btn.disabled) return;
    ev.preventDefault();
    var card = btn.closest('.prest-up__card');
    if (!card) return;
    card.querySelectorAll('.prest-up__size').forEach(function (b) { b.classList.remove('is-on'); });
    btn.classList.add('is-on');
    var add = card.querySelector('.prest-up__add');
    if (add) add.textContent = tAdd();
  });

  /* ---------- Upsell hinzufuegen ---------- */
  on('.prest-up__add', 'click', function (ev, addBtn) {
    ev.preventDefault();
    if (BUSY) return;
    var card = addBtn.closest('.prest-up__card');
    if (!card) return;

    var chosen = card.querySelector('.prest-up__size.is-on');
    if (!chosen) {
      var avail = card.querySelectorAll('.prest-up__size:not(.is-out):not([disabled])');
      if (avail.length === 1) { chosen = avail[0]; chosen.classList.add('is-on'); }
    }
    if (!chosen) {
      addBtn.textContent = tChoose();
      setTimeout(function () { addBtn.textContent = tAdd(); }, 1800);
      return;
    }

    var vid = chosen.getAttribute('data-vid');
    if (!vid) return;

    BUSY = true;
    addBtn.setAttribute('data-busy', '1');
    addBtn.textContent = tAdding();

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) throw new Error(d && d.description ? d.description : 'fehlgeschlagen');
          return d;
        });
      })
      .then(function () { return refreshDrawer(); })
      .catch(function (e) {
        log(e);
        addBtn.textContent = tUnavailable();
        setTimeout(function () { addBtn.textContent = tAdd(); }, 2400);
      })
      .then(function () {
        BUSY = false;
        if (addBtn && addBtn.removeAttribute) addBtn.removeAttribute('data-busy');
      });
  });

  document.addEventListener('DOMContentLoaded', function () { setTimeout(pfeileAktualisieren, 300); });
  window.addEventListener('load', function () { setTimeout(pfeileAktualisieren, 500); });
})();
